import React, { FC, ReactNode, useState } from 'react';
import { Drawer } from 'antd';
import BookingSummary from '../BookingSummary';
import { useFeeEstimate } from '../FeeCard';
import { formatRange } from '../../utils/consultation-fee';

type Props = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  busy?: boolean;
  hint?: ReactNode;
};

const BASIS_NOTE = {
  'medicare-assumed': 'Medicare assumed',
  medicare: 'With Medicare',
  'medicare-to-follow': 'With Medicare',
  dva: 'With DVA',
  none: 'Private fee',
};

// Phones only (styled in uplift.css): the ADHD portal's sticky footer — the fee, with the
// appointment and fee details in a bottom sheet, and the step's full-width action.
const MobileActionBar: FC<Props> = ({
  label, onClick, disabled, busy, hint,
}) => {
  const [sheetOpen, setSheetOpen] = useState(false);
  const estimate = useFeeEstimate();

  return (
    <div className="m-only">
      <div className="mfoot-spacer" aria-hidden />
      <div className="mfoot">
        {estimate && (
          <button type="button" className="fee-row" onClick={() => setSheetOpen(true)} aria-label="Show appointment and fee details">
            <span>
              <b>Out of pocket</b>
              <small>{BASIS_NOTE[estimate.basis]}</small>
            </span>
            <span>
              <span className="amt">{formatRange(estimate.gap)}</span>
              <em>Details ⌃</em>
            </span>
          </button>
        )}
        <button type="button" className="cta" disabled={disabled || busy} onClick={onClick}>
          {busy ? 'Please wait…' : label}
        </button>
        {hint && <p className="hint">{hint}</p>}
      </div>
      <Drawer
        placement="bottom"
        height="auto"
        visible={sheetOpen}
        onClose={() => setSheetOpen(false)}
        title="Your appointment"
        className="bk-sheet-drawer"
        bodyStyle={{ padding: 0, maxHeight: '75vh', overflowY: 'auto' }}
      >
        <div className="bk bk-sheet">
          <BookingSummary />
        </div>
      </Drawer>
    </div>
  );
};

export default MobileActionBar;
